"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.avatar.setup.title': '设置您的头像',
    'onboarding.avatar.config.title': '头像配置',
    'onboarding.avatar.name.label': '头像名称',
    'onboarding.avatar.name.placeholder': '输入头像名称',
    'onboarding.avatar.name.required': '*',
    'onboarding.avatar.age.label': '头像年龄',
    'onboarding.avatar.age.placeholder': '输入头像年龄',
    'onboarding.avatar.gender.label': '头像性别',
    'onboarding.avatar.gender.placeholder': '-- 选择性别 --',
    'onboarding.avatar.gender.male': '男性',
    'onboarding.avatar.gender.female': '女性',
    'onboarding.avatar.voice.label': '头像声音',
    'onboarding.avatar.voice.placeholder': '-- 选择声音 --',
    'onboarding.avatar.voice.loading': '正在加载声音...',
    'onboarding.avatar.voice.select_gender_first': '请先选择性别',
    'onboarding.avatar.voice.male': '男性',
    'onboarding.avatar.voice.female': '女性',
    'onboarding.avatar.description.label': '头像描述',
    'onboarding.avatar.description.placeholder': '描述您头像的个性和特征',
    'onboarding.avatar.image.label': '头像图片',
    'onboarding.avatar.image.placeholder': '上传头像图片...',
    'onboarding.avatar.name': '头像名称',
};
